import React from "react";
import cn from "classnames";
import t from "lib/i18n";
import "styles/components/error-message.scss";
import "styles/components/via-find.scss";

const ErrorMessage = ({ errors, message = null, name, noBorder = false }) => {
  let errorMessage = message;

  if (!message) {
    let errorType;
    let errorField = name;

    if (Array.isArray(name)) {
      errorField = name.filter?.(errorType => errors[errorType])?.[0];
      errorType = errors?.[errorField]?.type;
    } else {
      errorType = errors?.[name]?.type;
    }

    if (errorType) {
      const errorName = `errors.${errorField}.${errorType}`;
      errorMessage = t(errorName) ?? errorName;
    }
  }

  if (!errorMessage) {
    return null;
  }

  return (
    <div
      className={cn("otrl-jp__error-message", { "otrl-jp__error-message--no-border": noBorder })}
    >
      {errorMessage}
    </div>
  );
};

export default ErrorMessage;
